<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Riwayat QRIS</li>
              </ol>
            </div>
            <h4 class="page-title">Riwayat QRIS</h4>
          </div>
        </div>
      </div>

    <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
              <div class="row mb-3">
                <div class="col-12 col-md-4">
                    <label for="" style="margin-top: 10px;">Tanggal Riwayat</label>
                    <date-picker required style="width: 100%" v-model="filter.date" :placeholder="'Dari - Sampai'" format="DD/MM/YYYY" range></date-picker>
                </div>
                <div class="col-12 col-md-4">
                    <button class="btn btn-primary" @click="loadData" style="margin-top: 33px;">Filter</button>
                </div>
            </div>
            <div class="wrapper-table-default">
                <div class="table-responsive">
                    <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Tanggal</th>
                                <th>Issuer Name</th>
                                <th>Nama Merchant</th>
                                <th>Merchant Pan</th>
                                <th>Merchant Code</th>
                                <th>Terminal ID</th>
                                <th>Product Code</th>
                                <th>Bill Number</th>
                                <th>Jumlah</th>
                                <th>Tips</th>
                                <th>Status</th>
                                <th>Aksi</th>
                            </tr>
                        </thead>
                        <!-- <tbody v-if="filter.date[0] == null || filter.date[1] == null">
                            <tr>
                                <td colspan="11" class="text-center">Mohon mengisi tanggal pencarian riwayat untuk mendapatkan data</td>
                            </tr>
                        </tbody> -->
                        <tbody>
                            <tr v-for="(item) in dataTransaction" :key="item.id">
                                <td>{{convertDate(item.date)}}</td>
                                <td>{{item.merchantName}}</td>
                                <td>{{item.merchantPan}}</td>
                                <td>{{item.merchantCode}}</td>
                                <td>{{item.issuerName}}</td>
                                <td>{{item.terminalId}}</td>
                                <td>{{item.productCode}}</td>
                                <td>{{item.billNumber}}</td>
                                <td>{{item.amount}}</td>
                                <td>{{item.tips}}</td>
                                <td>{{item.status}}</td>
                                <td>
                                    <a class="btn btn-primary" href="#!" @click.prevent="loadDetail(item.id)"><i class="fas fa-eye"></i> Detail</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
      </div>
      
      <div class="modal fade" id="modalDetail" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mt-0" id="mySmallModalLabel">
                        <span v-if="loadingDetail">Loading ...</span>
                        <span v-else>Detail Riwayat QRIS</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="card card-loader d-flex" v-if="loadingDetail" style="height: 50vh; background-color: transparent">
                        <div class="justify-content-center">
                            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p class="mt-2">Loading</p>
                        </div>
                    </div>

                    <div v-else>
                        <div class="row align-items-center" style="margin-bottom: 20px">
                            <div class="col-12 col-md-9">
                                <div class="d-flex align-items-center">
                                    <table>
                                        <tr>
                                            <td><b>Tanggal Transaksi</b></td>
                                            <td>: {{ dataDetail['Tanggal Transaksi'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Nama Merchant</b></td>
                                            <td>: {{ dataDetail['Nama Merchant'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>NMID</b></td>
                                            <td>: {{ dataDetail['Lokasi Merchant'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>NMID</b></td>
                                            <td>: {{ dataDetail['NMID'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>MPAN</b></td>
                                            <td>: {{ dataDetail['MPAN'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>MID</b></td>
                                            <td>: {{ dataDetail['MID'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Kode User</b></td>
                                            <td>: {{ dataDetail['Kode User'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Terminal</b></td>
                                            <td>: {{ dataDetail['Terminal'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Nama User</b></td>
                                            <td>: {{ dataDetail['Nama User'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Customer PAN</b></td>
                                            <td>: {{ dataDetail['Customer PAN'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Issuer Name</b></td>
                                            <td>: {{ dataDetail['Issuer Name'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Nomor Referensi</b></td>
                                            <td>: {{ dataDetail['Nomor Referensi'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Nomor Referensi</b></td>
                                            <td>: {{ dataDetail['Nomor Referensi'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Tanggal Transaksi</b></td>
                                            <td>: {{ dataDetail['Nomor Referensi'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Nominal</b></td>
                                            <td>: {{ dataDetail['Nominal'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Tips</b></td>
                                            <td>: {{ dataDetail['Tips'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Status</b></td>
                                            <td>: {{ dataDetail['Status'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Keterangan Status</b></td>
                                            <td>: {{ dataDetail['Keterangan Status'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Response Code</b></td>
                                            <td>: {{ dataDetail['Response Code'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>MDR</b></td>
                                            <td>: {{ dataDetail['MDR'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Nominal MDR</b></td>
                                            <td>: {{ dataDetail['Nominal MDR'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Nominal Net</b></td>
                                            <td>: {{ dataDetail['Nominal Net'] }}</td>
                                        </tr>
                                        <tr>
                                            <td><b>Kode Cabang</b></td>
                                            <td>: {{ dataDetail['Kode Cabang'] }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row d-flex justify-content-center">
                        <a href="#" class="btn btn-primary" data-dismiss="modal">Tutup</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment"
import fileDownload from 'js-file-download'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    data() {
        return {
            loading: false,
            loadingDetail: true,

            filter: {
                date: [null,null],
            },

            dataDetail : null,
            dataTransaction: [],
        }
    },
    components: {
        DatePicker
    },
    methods: {
        loadDetail(id) {
            this.loadingDetail = true

            $('#modalDetail').modal('show')
            
            this.$http.get(`${this.API_URL}qris-history/${id}`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` },
            })
            .then(response => {
                const result = response.data;
                if(result.success) {
                    this.dataDetail = result.data
                    setTimeout(() => {
                        this.loadingDetail = false;
                    }, 100);
                }else {
                    this.sAlert('error', result.message)
                    this.loadingDetail = false;
                }
            })
            .catch(error => {
                this.loadingDetail = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        loadData() {
            if(this.filter.date[0] == null || this.filter.date[1] == null){
                this.sAlert('error', 'Harap mengisi tanggal awal dan tanggal akhir')
                return
            }
            
            this.loading = true;

            this.$http.get(`${this.API_URL}qris-history`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` },
                params: {
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                }
            })
            .then(response => {
                this.loading = false;
                const result = response.data;
                if(result.success) {
                    this.dataTransaction = result.data
                    setTimeout(() => {
                        this.dataTableSearch()
                    }, 500);
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                this.loading = false;
                this.errorHandler(error)
            });
        },
        convertDate(date){
            return moment(date).format('DD MMMM YYYY')
        }
    },
    mounted() {
        // this.loadData()
    }
}
</script>